export default {
  __INIT() {
    return {
      root: '/',
    };
  },
  ROUTING__SET_ROOT(state, { payload }) {
    const root = payload;
    return { ...state, root };
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/routing/handlers.js